import { render, staticRenderFns } from "./D4.vue?vue&type=template&id=0572452e&scoped=true"
import script from "./D4.vue?vue&type=script&lang=js"
export * from "./D4.vue?vue&type=script&lang=js"
import style0 from "./D4.vue?vue&type=style&index=0&id=0572452e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0572452e",
  null
  
)

export default component.exports